import { getAuthHeaders, getBaseUrl } from './apiClient';

export type LessonInstanceRecord = {
  user_email: string;
  lesson_id: string;
  plan_id: string;
  lesson_index: number;
  status: string;
  created_at?: string;
  updated_at?: string;
  completion?: {
    status?: 'not_started' | 'in_progress' | 'completed' | string;
    started_at?: string | null;
    completed_at?: string | null;
    last_viewed_at?: string | null;
  };
  lesson: any;
  source?: any;
};

export const lessonInstancesService = {
  list: async (planId: string): Promise<{ items: LessonInstanceRecord[]; count: number }> => {
    const baseUrl = getBaseUrl();
    const headers = await getAuthHeaders();
    const resp = await fetch(`${baseUrl}/secure/learning-plans/${encodeURIComponent(planId)}/lessons`, {
      method: 'GET',
      headers,
    });
    const raw = await resp.text().catch(() => '');
    let data: any = {};
    try { data = raw ? JSON.parse(raw) : {}; } catch { data = {}; }
    if (!resp.ok) {
      throw new Error(data?.error || raw || `Failed to list lesson instances (${resp.status})`);
    }
    return data as { items: LessonInstanceRecord[]; count: number };
  },

  get: async (planId: string, lessonIndex: number): Promise<LessonInstanceRecord> => {
    const baseUrl = getBaseUrl();
    const headers = await getAuthHeaders();
    const resp = await fetch(`${baseUrl}/secure/learning-plans/${encodeURIComponent(planId)}/lessons/${encodeURIComponent(String(lessonIndex))}`, {
      method: 'GET',
      headers,
    });
    const raw = await resp.text().catch(() => '');
    let data: any = {};
    try { data = raw ? JSON.parse(raw) : {}; } catch { data = {}; }
    if (!resp.ok) {
      const err: any = new Error(data?.error || raw || `Failed to fetch lesson instance (${resp.status})`);
      err.status = resp.status;
      throw err;
    }
    return data as LessonInstanceRecord;
  },

  markViewed: async (planId: string, lessonIndex: number): Promise<LessonInstanceRecord> => {
    const baseUrl = getBaseUrl();
    const headers = await getAuthHeaders();
    const resp = await fetch(`${baseUrl}/secure/learning-plans/${encodeURIComponent(planId)}/lessons/${encodeURIComponent(String(lessonIndex))}`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ action: 'mark_viewed' }),
    });
    const raw = await resp.text().catch(() => '');
    let data: any = {};
    try { data = raw ? JSON.parse(raw) : {}; } catch { data = {}; }
    if (!resp.ok) {
      throw new Error(data?.error || raw || `Failed to mark lesson viewed (${resp.status})`);
    }
    return data as LessonInstanceRecord;
  },

  markCompleted: async (planId: string, lessonIndex: number): Promise<LessonInstanceRecord> => {
    const baseUrl = getBaseUrl();
    const headers = await getAuthHeaders();
    const resp = await fetch(`${baseUrl}/secure/learning-plans/${encodeURIComponent(planId)}/lessons/${encodeURIComponent(String(lessonIndex))}`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ action: 'mark_completed' }),
    });
    const raw = await resp.text().catch(() => '');
    let data: any = {};
    try { data = raw ? JSON.parse(raw) : {}; } catch { data = {}; }
    if (!resp.ok) {
      throw new Error(data?.error || raw || `Failed to mark lesson completed (${resp.status})`);
    }
    return data as LessonInstanceRecord;
  },
};


